import { LOCAL_AREA_LANDSCAPES } from './localAreaLandscapes.js';

export const LOCAL_AREAS = [
  { slug: 'exeter', name: 'Exeter', county: 'Devon' },
  { slug: 'plymouth', name: 'Plymouth', county: 'Devon' },
  { slug: 'torbay', name: 'Torbay', county: 'Devon' },
  { slug: 'torquay', name: 'Torquay', county: 'Devon' },
  { slug: 'paignton', name: 'Paignton', county: 'Devon' },
  { slug: 'barnstaple', name: 'Barnstaple', county: 'Devon' },
  { slug: 'newton-abbot', name: 'Newton Abbot', county: 'Devon' },
  { slug: 'tiverton', name: 'Tiverton', county: 'Devon' },
  { slug: 'bideford', name: 'Bideford', county: 'Devon' },
  { slug: 'teignmouth', name: 'Teignmouth', county: 'Devon' },
  { slug: 'exmouth', name: 'Exmouth', county: 'Devon' },
  { slug: 'dawlish', name: 'Dawlish', county: 'Devon' },
  { slug: 'totnes', name: 'Totnes', county: 'Devon' },
  { slug: 'dartmouth', name: 'Dartmouth', county: 'Devon' },
  { slug: 'kingsbridge', name: 'Kingsbridge', county: 'Devon' },
  { slug: 'salcombe', name: 'Salcombe', county: 'Devon' },
  { slug: 'honiton', name: 'Honiton', county: 'Devon' },
  { slug: 'seaton', name: 'Seaton', county: 'Devon' },
  { slug: 'sidmouth', name: 'Sidmouth', county: 'Devon' },
  { slug: 'south-molton', name: 'South Molton', county: 'Devon' },
  { slug: 'axminster', name: 'Axminster', county: 'Devon' },
  { slug: 'okehampton', name: 'Okehampton', county: 'Devon' },
  { slug: 'tavistock', name: 'Tavistock', county: 'Devon' },
  { slug: 'crediton', name: 'Crediton', county: 'Devon' },
  { slug: 'ilfracombe', name: 'Ilfracombe', county: 'Devon' },
  { slug: 'cullompton', name: 'Cullompton', county: 'Devon' },
  { slug: 'ivybridge', name: 'Ivybridge', county: 'Devon' },

  { slug: 'truro', name: 'Truro', county: 'Cornwall' },
  { slug: 'falmouth', name: 'Falmouth', county: 'Cornwall' },
  { slug: 'penzance', name: 'Penzance', county: 'Cornwall' },
  { slug: 'newquay', name: 'Newquay', county: 'Cornwall' },
  { slug: 'st-austell', name: 'St Austell', county: 'Cornwall' },
  { slug: 'camborne', name: 'Camborne', county: 'Cornwall' },
  { slug: 'redruth', name: 'Redruth', county: 'Cornwall' },
  { slug: 'bodmin', name: 'Bodmin', county: 'Cornwall' },
  { slug: 'helston', name: 'Helston', county: 'Cornwall' },
  { slug: 'liskeard', name: 'Liskeard', county: 'Cornwall' },
  { slug: 'launceston', name: 'Launceston', county: 'Cornwall' },
  { slug: 'saltash', name: 'Saltash', county: 'Cornwall' },
  { slug: 'torpoint', name: 'Torpoint', county: 'Cornwall' },
  { slug: 'wadebridge', name: 'Wadebridge', county: 'Cornwall' },
  { slug: 'padstow', name: 'Padstow', county: 'Cornwall' },
  { slug: 'bude', name: 'Bude', county: 'Cornwall' },
  { slug: 'st-ives', name: 'St Ives', county: 'Cornwall' },
  { slug: 'hayle', name: 'Hayle', county: 'Cornwall' },
  { slug: 'callington', name: 'Callington', county: 'Cornwall' },
  { slug: 'lostwithiel', name: 'Lostwithiel', county: 'Cornwall' },
  { slug: 'looe', name: 'Looe', county: 'Cornwall' },
  { slug: 'fowey', name: 'Fowey', county: 'Cornwall' },
  { slug: 'perranporth', name: 'Perranporth', county: 'Cornwall' },
  { slug: 'camelford', name: 'Camelford', county: 'Cornwall' },
  { slug: 'par', name: 'Par', county: 'Cornwall' },

  { slug: 'cardiff', name: 'Cardiff', county: 'South Wales' },
  { slug: 'portsmouth', name: 'Portsmouth', county: 'Hampshire' },
  { slug: 'glasgow', name: 'Glasgow', county: 'Scotland' },
  { slug: 'london', name: 'London', county: 'Greater London' },
  { slug: 'birmingham', name: 'Birmingham', county: 'West Midlands' },

  { slug: 'edinburgh', name: 'Edinburgh', county: 'Scotland' },
  { slug: 'manchester', name: 'Manchester', county: 'Greater Manchester' },
  { slug: 'liverpool', name: 'Liverpool', county: 'Merseyside' },
  { slug: 'leeds', name: 'Leeds', county: 'West Yorkshire' },
  { slug: 'bristol', name: 'Bristol', county: 'Bristol' },
  { slug: 'newcastle-upon-tyne', name: 'Newcastle upon Tyne', county: 'Tyne and Wear' },
  { slug: 'nottingham', name: 'Nottingham', county: 'Nottinghamshire' },
  { slug: 'sheffield', name: 'Sheffield', county: 'South Yorkshire' },
  { slug: 'brighton', name: 'Brighton', county: 'East Sussex' },
  { slug: 'oxford', name: 'Oxford', county: 'Oxfordshire' },
  { slug: 'norwich', name: 'Norwich', county: 'Norfolk' },
  { slug: 'sunderland', name: 'Sunderland', county: 'Tyne and Wear' },
  { slug: 'worcester', name: 'Worcester', county: 'Worcestershire' },
  { slug: 'gloucester', name: 'Gloucester', county: 'Gloucestershire' },
  { slug: 'belfast', name: 'Belfast', county: 'Northern Ireland' },
  { slug: 'aberdeen', name: 'Aberdeen', county: 'Scotland' },
  { slug: 'southampton', name: 'Southampton', county: 'Hampshire' },
  { slug: 'cambridge', name: 'Cambridge', county: 'Cambridgeshire' },
  { slug: 'derby', name: 'Derby', county: 'Derbyshire' },
  { slug: 'hull', name: 'Hull', county: 'East Yorkshire' },
  { slug: 'swansea', name: 'Swansea', county: 'South Wales' },
  { slug: 'stoke-on-trent', name: 'Stoke-on-Trent', county: 'Staffordshire' },
  { slug: 'middlesbrough', name: 'Middlesbrough', county: 'North Yorkshire' },
  { slug: 'reading', name: 'Reading', county: 'Berkshire' },
  { slug: 'northampton', name: 'Northampton', county: 'Northamptonshire' },
  { slug: 'ipswich', name: 'Ipswich', county: 'Suffolk' },
  { slug: 'coventry', name: 'Coventry', county: 'West Midlands' }
];

export const LOCATIONS_HUB_COUNTY_ORDER = [
  'Devon',
  'Cornwall',
  'South Wales',
  'Gloucestershire',
  'Worcestershire',
  'West Midlands',
  'Staffordshire',
  'Derbyshire',
  'Nottinghamshire',
  'Northamptonshire',
  'Oxfordshire',
  'Berkshire',
  'Greater London',
  'East Sussex',
  'Hampshire',
  'Suffolk',
  'Norfolk',
  'Cambridgeshire',
  'Bristol',
  'Merseyside',
  'Greater Manchester',
  'South Yorkshire',
  'West Yorkshire',
  'East Yorkshire',
  'North Yorkshire',
  'Tyne and Wear',
  'Scotland',
  'Northern Ireland'
];

const bySlug = new Map(
  LOCAL_AREAS.map((a) => [
    a.slug,
    { ...a, landscape: LOCAL_AREA_LANDSCAPES[a.slug] || '' }
  ])
);

export function getAreaBySlug(slug) {
  if (!slug || typeof slug !== 'string') return undefined;
  return bySlug.get(slug.toLowerCase());
}

export function groupAreasByCounty() {
  const groups = {};
  for (const a of LOCAL_AREAS) {
    if (!groups[a.county]) groups[a.county] = [];
    groups[a.county].push(a);
  }
  for (const key of Object.keys(groups)) {
    groups[key].sort((x, y) => x.name.localeCompare(y.name));
  }
  return groups;
}
